module.exports = __webpack_public_path__ + "img/icon-round-plus.341bad41.svg";